const actions = {
    FORM_DESIGN_CREATE_REQUEST: 'FORM_DESIGN_CREATE_REQUEST',
    FORM_DESIGN_CREATE_SUCCESS: 'FORM_DESIGN_CREATE_SUCCESS',
    FORM_DESIGN_CREATE_ERROR: 'FORM_DESIGN_CREATE_ERROR',

    FORM_DESIGN_READ_REQUEST: 'FORM_DESIGN_READ_REQUEST',
    FORM_DESIGN_READ_SUCCESS: 'FORM_DESIGN_READ_SUCCESS',
    FORM_DESIGN_READ_ERROR: 'FORM_DESIGN_READ_ERROR',

    FORM_DESIGN_READ_ALL_REQUEST: 'FORM_DESIGN_READ_ALL_REQUEST',
    FORM_DESIGN_READ_ALL_SUCCESS: 'FORM_DESIGN_READ_ALL_SUCCESS',
    FORM_DESIGN_READ_ALL_ERROR: 'FORM_DESIGN_READ_ALL_ERROR',

    FORM_DESIGN_UPDATE_REQUEST: 'FORM_DESIGN_UPDATE_REQUEST',
    FORM_DESIGN_UPDATE_SUCCESS: 'FORM_DESIGN_UPDATE_SUCCESS',
    FORM_DESIGN_UPDATE_ERROR: 'FORM_DESIGN_UPDATE_ERROR',

    FORM_DESIGN_DELETE_REQUEST: 'FORM_DESIGN_DELETE_REQUEST',
    FORM_DESIGN_DELETE_SUCCESS: 'FORM_DESIGN_DELETE_SUCCESS',
    FORM_DESIGN_DELETE_ERROR: 'FORM_DESIGN_DELETE_ERROR',

    FORM_DESIGN_PREVIEW_REQUEST: 'FORM_DESIGN_PREVIEW_REQUEST',
    FORM_DESIGN_PREVIEW_SUCCESS: 'FORM_DESIGN_PREVIEW_SUCCESS',
    FORM_DESIGN_PREVIEW_ERROR: 'FORM_DESIGN_PREVIEW_ERROR',

    FORM_DESIGN_RESET_STATE: 'FORM_DESIGN_RESET_STATE',
    FORM_DESIGN_CHANGE: 'FORM_DESIGN_CHANGE',

    createFormDesign: request => ({
        type: actions.FORM_DESIGN_CREATE_REQUEST,
        request,
    }),
    readFormDesign: id => ({
        type: actions.FORM_DESIGN_READ_REQUEST,
        id,
    }),
    readAllFormDesign: request => ({
        type: actions.FORM_DESIGN_READ_ALL_REQUEST,
        request,
    }),
    updateFormDesign: (id, request) => ({
        type: actions.FORM_DESIGN_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteFormDesign: id => ({
        type: actions.FORM_DESIGN_DELETE_REQUEST,
        id,
    }),
    resetFormDesign: id => ({
        type: actions.FORM_DESIGN_RESET_STATE,
        id,
    }),
    previewFormDesign: request => ({
        type: actions.FORM_DESIGN_PREVIEW_REQUEST,
        request,
    }),
    changeFormDesign: (request, reset = false) => ({
        type: actions.FORM_DESIGN_CHANGE,
        request,
        reset,
    }),
};
export default actions;
